export const msalConfig = {
  auth: {
    clientId: '12bdb30b-520f-4bc5-870e-c7b8f5b5690c',
    authority: 'https://login.microsoftonline.com/aed3f71f-cc07-482b-81fe-013321550d8e',
    redirectUri: window.location.protocol + '//' + window.location.host,
  },
  cache: {
    cacheLocation: "sessionStorage",
    storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
  },
};
  
export const loginApiRequest = {
  scopes: ['user.read'],
};
  